module.exports = __webpack_public_path__ + "static/media/WeChat_Guide_Chin_Apple.ec950bf7.docx";